import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Box, Button, Typography } from "@mui/material";
import CheckmarkPrimary from "../assets/images/check-primary-with-bg.png";

const DiscountApplyModal = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="success-modal-title"
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: "#fff",
          borderRadius: "20px",
          padding: {
            xs: "15px",
            sm: "15px",
            md: 0,
          },
          maxWidth: {
            xs: "95%",
            sm: "450px",
            md: "500px",
          },
          width: "100%",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
      }}
    >
      <DialogContent>
        <Box textAlign="center">
          <Box mb={3}>
            <img
              src={CheckmarkPrimary}
              alt="Success"
              style={{ width: 64, height: 64 }}
            />
          </Box>

          {/* Heading */}
          <Typography
            id="success-modal-title"
            variant="h6"
            fontWeight={600}
            sx={{
              fontSize: {
                xs: "22px",
                sm: "26px",
                md: "30px",
              },
              color: "#2A4876",
              mb: 1,
            }}
          >
            Welcome to Echo! 🎉
          </Typography>

          {/* Subheading */}
          <Typography
            sx={{
              fontSize: {
                xs: "14px",
                sm: "16px",
                md: "18px",
              },
              fontWeight: 500,
              color: "#2A4876",
              mb: 2,
              textTransform: "capitalize",
            }}
          >
            We’re so excited to have you join our community!
          </Typography>

          {/* Body */}
          <Typography
            sx={{
              fontSize: {
                xs: "13px",
                sm: "14px",
                md: "15px",
              },
              lineHeight: 1.6,
              color: "#152134",
              textAlign: "center",
              mb: 3,
              px: {
                xs: 1,
                sm: 2,
                md: 4,
              },
            }}
          >
            When you sign up with a discount code, your payment info is
            collected so your subscription can continue automatically once your
            discount period ends. You’ll be reminded via email one week before
            your payment method is charged, and you can cancel anytime before
            your next billing cycle if your plans change. <br />
            <br />
            We can’t wait to help you make the most of your experience on Echo!
          </Typography>

          <Button
            onClick={onClose}
            sx={{
              backgroundColor: "#2A4876",
              color: "#fff",
              textTransform: "none",
              borderRadius: "50px",
              width: {
                xs: "100%",
                sm: "70%",
              },
              height: {
                xs: "40px",
                sm: "48px",
              },
              fontSize: {
                xs: "14px",
                sm: "16px",
              },
              fontWeight: 600,
              mx: "auto",
              display: "block",
              "&:hover": {
                backgroundColor: "#1e365c",
              },
            }}
          >
            Done
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DiscountApplyModal;
